import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import PrivacyNoticeContent from '../components/PrivacyNoticeContent';

export default function PrivacyNoticePage() {
  const navigate = useNavigate();

  const handleBack = () => {
    // Go back in browser history if possible, else navigate to home
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate('/');
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      background: '#f8f9fc',
      display: 'flex',
      justifyContent: 'center',
      padding: '40px 20px',
      position: 'relative',
    }}>
      {/* Back button */}
      <button
        onClick={handleBack}
        style={{
          position: 'absolute',
          top: '20px',
          left: '20px',
          width: '40px',
          height: '40px',
          background: 'white',
          border: '1px solid #e4e8f0',
          borderRadius: '10px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: 'pointer',
          boxShadow: '0 1px 4px rgba(0,0,0,0.06)',
        }}
        aria-label="Go back"
      >
        <ArrowLeft size={20} color="#001a4d" />
      </button>

      <div style={{
        maxWidth: '680px',
        width: '100%',
      }}>
        {/* Header */}
        <div style={{
          textAlign: 'center',
          marginBottom: '32px',
        }}>
          <div style={{
            background: '#F5C400',
            border: '3px solid #111',
            borderRadius: '8px',
            display: 'inline-block',
            padding: '8px 24px',
            marginBottom: '12px',
          }}>
            <div style={{
              fontFamily: "'Oswald', sans-serif",
              fontSize: '28px',
              fontWeight: 700,
              color: '#111',
              letterSpacing: '6px',
            }}>VCIN</div>
          </div>
        </div>

        {/* Document */}
        <div style={{
          background: 'white',
          borderRadius: '12px',
          padding: '40px 36px',
          boxShadow: '0 2px 12px rgba(0,0,0,0.08)',
          fontFamily: "'Inter', sans-serif",
          color: '#1a1a2e',
          lineHeight: 1.7,
          fontSize: '14.5px',
        }}>
          <PrivacyNoticeContent />
        </div>

        <div style={{
          marginTop: '20px',
          fontSize: '11px',
          color: 'rgba(0,0,0,0.3)',
          textAlign: 'center',
          lineHeight: 1.6,
        }}>
          VCIN — Vehicle Crime Intelligence Network
        </div>
      </div>
    </div>
  );
}
